"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _ = require("lodash");
const myRequire = require; // Note (JQ):  slimy hack to make the react-native and angular package loaders behave.
class Platform {
    static detectPlatform() {
        return this.disableDetection ? undefined :
            (Platform.getBrowserPlatform() || Platform.getReactNativePlatform() || Platform.getNodePlatform());
    }
    static getNodePlatform(params = {}) {
        try {
            const os = params.platform ? params : myRequire('os');
            const platform = os.platform();
            return {
                name: platform === 'win32' ? 'windows' : platform,
                version: os.release(),
            };
        }
        catch (error) {
            return undefined;
        }
    }
    static getBrowserPlatform() {
        try {
            const userAgent = _.get(window, 'navigator.userAgent');
            const matches = /\(([^\)]+)\)/.exec(userAgent);
            return this.guessUserAgentPlatform(matches && matches[1] &&
                matches[1].replace(/; ?/g, ',').replace(/ /g, '-').replace(/_/g, '.').toLowerCase());
        }
        catch (error) {
            return undefined;
        }
    }
    static getReactNativePlatform(params = {}) {
        try {
            const product = _.get(global, 'navigator.product', undefined);
            if (product !== 'ReactNative') {
                return undefined;
            }
            else {
                const { Platform } = params.Platform ? params : myRequire('react-native');
                return {
                    name: Platform.OS,
                    version: Platform.Version,
                };
            }
        }
        catch (error) {
            return undefined;
        }
    }
    static guessUserAgentPlatform(userAgentFragment) {
        let matches = null;
        const getPlatformVersion = (header, versionMatch) => {
            const platform = {
                name: header,
            };
            if (versionMatch && versionMatch[1]) {
                platform.version = versionMatch[1];
            }
            return platform;
        };
        if (!userAgentFragment) {
            return undefined;
        }
        else if (matches = /xbox/.exec(userAgentFragment)) {
            return getPlatformVersion('xbox');
        }
        else if (matches = /windows-mobile-([\d.]+)?/.exec(userAgentFragment)) {
            return getPlatformVersion('windows-mobile', matches);
        }
        else if (matches = /windows-nt-([\d.]+)?/.exec(userAgentFragment)) {
            return getPlatformVersion('windows', matches);
        }
        else if (matches = /android-([\d.]+)?/.exec(userAgentFragment)) {
            return getPlatformVersion('android', matches);
        }
        else if (matches = /mac-os-x-([\d.]+)?/.exec(userAgentFragment)) {
            return getPlatformVersion('mac', matches);
        }
        else if (matches = /os-([\d.]+)?-like-mac-os-x/.exec(userAgentFragment)) {
            return getPlatformVersion('ios', matches);
        }
        else if (matches = /linux/.exec(userAgentFragment)) {
            return getPlatformVersion('linux');
        }
        else {
            return undefined;
        }
    }
}
exports.Platform = Platform;
Platform.disableDetection = false;
//# sourceMappingURL=platform.js.map